module.exports = __webpack_public_path__ + "img/share-icon.01a5551d.svg";